import classnames from 'classnames'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { Table } from 'semantic-ui-react'

import './Score.css'

class Score extends PureComponent {
  render() {
    const { match, printable } = this.props
    if (!match) {
      return null
    }
    const classes = classnames('MatchScore', 'match', match.status)

    if (match.is_deferred) {
      return (
        <Table.Cell className={classes} collapsing title="Pospuesto">
          <small>{printable ? 'Pospuesto' : 'posp.'}</small>
        </Table.Cell>
      )
    }

    if (match.is_both_lose) {
      return (
        <Table.Cell className={classes} collapsing title="Pierden Ambos">
          <small>{printable ? 'Pierden Ambos' : 'pierden'}</small>
        </Table.Cell>
      )
    }

    return (
      <Table.Cell className={classes} collapsing>
        {match.local_walkover ? 'W' : match.local_goals} ~ {match.visitor_walkover ? 'W' : match.visitor_goals}
        {(!!match.local_definition_goals || !!match.visitor_definition_goals) && (
          <div>
            <sup>
              ({match.local_definition_goals}
              )&nbsp;&nbsp;&nbsp;~&nbsp;&nbsp;&nbsp;(
              {match.visitor_definition_goals})
            </sup>
          </div>
        )}
      </Table.Cell>
    )
  }
}

Score.propTypes = {
  match: PropTypes.object.isRequired,
  printable: PropTypes.bool,
}

Score.defaultProps = {
  printable: false,
}

export default Score
